import { fetchJson } from '@/utils/fetchJson';

export function postJson<T extends object>(
  url: RequestInfo | URL,
  options?: object | RequestInit & { body: object & BodyInit },
): Promise<T | undefined> {
  const opts = <RequestInit> {
    method: 'POST',
    ...options,
  };

  const headers = new Headers(opts.headers);
  if (!headers.has('content-type')) {
    headers.set('content-type', 'application/json');
  }

  if (opts.body && typeof opts.body !== 'string') {
    opts.body = JSON.stringify(opts.body);
  }

  return fetchJson(url, { ...opts, headers: Object.fromEntries(headers.entries()) });
}
